var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// metaの削除では適用済みのポリシーが解除されないため、社内画面では内容を明示して更新する
export var setReferrerPolicy = function (content) {
    var referrer = document.head.querySelector('meta[name="referrer"][data-hid="referrer"]') ||
        document.createElement('meta');
    referrer.setAttribute('name', 'referrer');
    referrer.setAttribute('content', content);
    referrer.setAttribute('data-hid', 'referrer');
    referrer.setAttribute('data-n-head', 'true');
    if (!referrer.parentNode)
        document.head.appendChild(referrer);
};
// 社内画面の起動前に共通scriptを読み込み、vue-metaが同じ要素を再利用できる属性を付ける
export var loadInternalHeadScripts = function (scripts) { return __awaiter(void 0, void 0, Promise, function () {
    var _loop_1, _i, scripts_1, definition;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function (definition) {
                    var script, loaded, parent;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                script = document.createElement('script');
                                script.async = Boolean(definition.async);
                                Object.keys(definition).forEach(function (attribute) {
                                    var value = definition[attribute];
                                    if (attribute === 'innerHTML') {
                                        script.innerHTML = value;
                                    }
                                    else {
                                        var name = ['hid', 'body'].includes(attribute) ? "data-" + attribute : attribute;
                                        script.setAttribute(name, value === undefined ? '' : String(value));
                                    }
                                });
                                script.setAttribute('data-n-head', 'true');
                                loaded = script.src && !script.async
                                    ? new Promise(function (resolve) {
                                        // 通常のHTMLと同様に、読み込みに失敗しても後続の起動処理を続ける
                                        script.onload = function () { return resolve(); };
                                        script.onerror = function () { return resolve(); };
                                    })
                                    : undefined;
                                parent = definition.body ? document.body : document.head;
                                parent.appendChild(script);
                                if (!loaded) return [3 /*break*/, 2];
                                return [4 /*yield*/, loaded];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                };
                _i = 0, scripts_1 = scripts;
                _a.label = 1;
            case 1:
                if (!(_i < scripts_1.length)) return [3 /*break*/, 4];
                definition = scripts_1[_i];
                return [5 /*yield**/, _loop_1(definition)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
